import { createSelector } from '@reduxjs/toolkit';
import type { UserModel } from './types';
import type { RootState } from '../store';

const selectState = (state: RootState): RootState['users'] => state.users;

export const selectUserById = createSelector(
    [
        (state: RootState) => state,
        (state: RootState) => selectState(state).records,
        (state: RootState, userId: string): string => userId,
    ],
    (state, records, userId): UserModel | undefined => records[userId],
);

export const selectUserDetailsLoading = createSelector(
    [selectState, (state: RootState, userId: string): string => userId],
    (state, userId): boolean => state.details[userId]?.isLoading ?? false,
);
